module.exports = __webpack_public_path__ + "img/Calendar.8210cd73.svg";